/* eslint-disable no-param-reassign */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Router from 'vue-router';
import lodash from 'lodash';
import VueLodash from 'vue-lodash/dist/vue-lodash.min';
import VueAuth from '@websanova/vue-auth';
import Auth from '@/components/Auth';
import VueFlatpickr from 'vue-flatpickr-component';
import draggable from 'vuedraggable';
import 'flatpickr/dist/flatpickr.css';
import Vuex from 'vuex';

// import App from './App';
import Products from './components/products/Products';
import Pharmacies from './components/pharmacy/Pharmacies';
import Pharmacy from './components/pharmacy/Pharmacy';
import PharmacyPage from './components/pharmacy/PharmacyPage';
import PharmacyEdit from './components/pharmacy/PharmacyEdit';
import PharmacyInfo from './components/pharmacy/PharmacyInfo';
import RackList from './components/pharmacy/rack/RackList';
import Shelf from './components/shelf/Shelf';
import Pack from './components/Pack';
import RackAdd from './components/pharmacy/rack/RackAdd';
import RackEdit from './components/pharmacy/rack/RackEdit';

import ProductEdit from './components/products/ProductEdit';
// import Reports from './components/Reports';
import Versions from './components/reports/Versions';
import InputMaterial from './components/html/InputMaterial';
import SelectMaterial from './components/html/SelectMaterial';
import RackOnPlan from './components/pharmacy/RackOnPlan';
import EditableCategory from './components/html/CatEdit';
import EditableTD from './components/EditableTD';
import DragablePoint from './components/html/DraggablePoint';
import CopyRack from './components/pharmacy/CopyRack';
import CopyShelf from './components/pharmacy/CopyShelf';
import LinkShelf from './components/pharmacy/LinkShelf';
import Users from './components/users/Users';
import UserAdd from './components/users/UserAdd';
import VersionAdd from './components/reports/VersionAdd';


const bearerDriver = require('./driver/jwt.js');
const routerDriver = require('@websanova/vue-auth/drivers/router/vue-router.2.x.js');
const axiousDriver = require('@websanova/vue-auth/drivers/http/axios.1.x.js');


// const apolloClient = new ApolloClient({
//   networkInterface: createNetworkInterface({
//     uri: '/api/graphql/?',
//     transportBatching: true,
//     connectToDevTools: true,
//   }),
// });
// const apolloProvider = new VueApollo({
//   defaultClient: apolloClient,
// });


Vue.use(Router);
// Vue.use(VueApollo, { apolloClient });
Vue.use(VueLodash, lodash);
Vue.use(Vuex);

Vue.router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Auth,
      meta: { auth: false, title: 'Авторизация' },
    },
    { path: '/', redirect: '/pharmacies/' },
    {
      path: '/pharmacies/',
      name: 'Pharmacies',
      component: Pharmacies,
      meta: { auth: true, title: 'Аптеки' },
      children: [
        // { path: 'new/', component: AddPharmacy },
      ],
    },
    {
      path: '/products/',
      meta: { auth: true, title: 'Товары' },
      name: 'Products',
      component: Products,
      children: [
        // { path: 'categories/', component: Categories },
        { path: ':id', component: ProductEdit },
      ],
    },
    { path: '/racks/:rack/edit/', component: RackEdit, name: 'editrack' },
    {
      path: '/pharmacies/:id/',
      component: Pharmacy,
      meta: { auth: true },
      props: { title: true },
      children: [
        { path: '/',
          redirect: 'info/',
          component: PharmacyPage,
          children: [
            { path: 'edit/',
              component: PharmacyEdit,
              name: 'pharmedit',
              children: [
                { path: 'copy/:rack/', component: CopyRack, name: 'copyrack' },
              ],
            },
            { path: 'info/', component: PharmacyInfo, name: 'pharminfo' },
          ],
        },
        { path: 'racks/',
          component: RackList,
        },
        { path: 'racks/new/', component: RackAdd },
        { path: 'racks/:rack/',
          component: RackList,
          children: [
            { path: ':shelf/copy/', component: CopyShelf, name: 'copyshelf' },
            { path: ':shelf/template/', component: LinkShelf, name: 'linkshelf' },
          ],
        },
        { path: 'racks/:rack/:shelf/',
          component: Shelf,
        },
      ],
    },
    {
      path: '/reports/',
      name: 'Reports',
      component: Versions,
      meta: { auth: true, title: 'Отчеты по аптекам' },
      children: [
        { path: 'add/', component: VersionAdd },
      ],
    },
    {
      path: '/users/',
      name: 'Users',
      component: Users,
      meta: { auth: true, title: 'Сотрудники' },
      children: [
        { path: ':user/', component: UserAdd },
      ],
    },
  ],
});


const store = new Vuex.Store({
  state: {
    shelf: null,
    user: localStorage.user !== undefined ? JSON.parse(localStorage.user) : {},
  },
  mutations: {
    shelf(state, shelf) {
      state.shelf = shelf;
    },
    user(state, user) {
      state.user = user;
    },
  },
  getters: {
    rackShelfInfo(state) {
      return state.shelf !== null ? `${state.shelf.rack.title} / #${state.shelf.number}` : '';
    },
  },
  actions: {
    auth({ commit, state }, user) {
      localStorage.user = JSON.stringify(user);
      commit('user', user);
    },
  },
});


Vue.use(VueAxios, axios);
Vue.use(VueAuth, {
  auth: bearerDriver,
  http: axiousDriver,
  router: routerDriver,
  refreshData: {
    enabled: false, // true by default.
  },
  loginData: { url: 'api/token/auth/', method: 'POST', redirect: '/', fetchUser: true },
  fetchData: { url: 'api/token/verify/', method: 'POST', enabled: true, data: { token: '' } },

});
Vue.config.productionTip = false;

Vue.component('flat-pickr', VueFlatpickr);
Vue.component('pack', Pack);
Vue.component('materialInput', InputMaterial);
Vue.component('materialSelect', SelectMaterial);
Vue.component('rackOnPlan', RackOnPlan);
Vue.component('editable-cat', EditableCategory);
Vue.component('editable-td', EditableTD);
Vue.component('draggable', draggable);
Vue.component('draggable-point', DragablePoint);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  data: {
    user: {},
  },
  store,
  router: Vue.router,
  template: '<App/>',
// eslint-disable-next-line global-require
  components: { App: require('./App') },
});




// WEBPACK FOOTER //
// ./src/main.js